module.exports = __webpack_public_path__ + "media/stylesheets/images/martech/cx_bg-a100f021e22c4510db20a0c840cafb42.jpg";